<div class="wrapper">
  <div class="header" style="display: flex; justify-content: space-between; align-items: center; padding-bottom: 20px;">
    <label class="header-label"
      style="text-align: left !important ;color: #27282D;font-size: 20px;font-weight: bold; margin-left: 1%;">Reminder
      and
      Escalations</label>
    <div class="search">
      <div class="search-bar">
        <input style="border-radius: 5px; height: 45px; padding-left: 20px !important;"
          placeholder="Search by Employee ID / Name" aria-label="Number" class="form-control" matinput="" type="text"
          [(ngModel)]="searchText" (keyup)="applyFilter(searchText)">
        <button *ngIf="searchText" type="button" class="clear-button" (click)="clearSearch()">
          <span class="material-symbols-outlined">close</span>
        </button>
        <button type="submit" class="msicon append_button" (click)="applyFilter(searchText)">
          <span class="material-symbols-outlined">search</span>
        </button>
      </div>
    </div>
    <div class="buttons-container">
      <button class="top-label-buttons" (click)="exportToExcel()">
        <span class="material-symbols-outlined icon-style">download</span>Export</button>
    </div>
  </div>
  <div class="data-grid" style="padding-left: 25px;">
    <table mat-table [dataSource]="data" class="mat-elevation-z8">

      <!-- Employee ID -->
      <ng-container matColumnDef="employeeId">
        <mat-header-cell *matHeaderCellDef>Employee ID</mat-header-cell>
        <mat-cell *matCellDef="let element">{{element.employeeId}}</mat-cell>
      </ng-container>

      <!-- First Name -->
      <ng-container matColumnDef="firstName">
        <mat-header-cell *matHeaderCellDef>First Name</mat-header-cell>
        <mat-cell *matCellDef="let element">{{element.firstName}}</mat-cell>
      </ng-container>

      <!-- Last Name -->
      <ng-container matColumnDef="lastName">
        <mat-header-cell *matHeaderCellDef>Last Name</mat-header-cell>
        <mat-cell *matCellDef="let element">{{element.lastName}}</mat-cell>
      </ng-container>

      <!-- Email -->
      <ng-container matColumnDef="emailAddress">
        <mat-header-cell *matHeaderCellDef style="min-width: 270px; width: 270px;">Email ID</mat-header-cell>
        <mat-cell *matCellDef="let element" style="min-width: 270px; width: 270px;">
          <div class="ellipsis" matTooltip="{{element.emailAddress}}">
            {{element.emailAddress}}
          </div>
        </mat-cell>
      </ng-container>

      <!-- Level -->
      <ng-container matColumnDef="level">
        <mat-header-cell *matHeaderCellDef>Level
          <button class="filter-button" [matMenuTriggerFor]="levelFilterMenu">
            <span class="material-symbols-outlined filter-icon">filter_alt</span>
          </button>
        </mat-header-cell>
        <mat-cell *matCellDef="let element">{{ getReminderLabel(element.level) }}</mat-cell>
      </ng-container>
      <mat-menu #levelFilterMenu="matMenu">
        <div class="status-filter-checkboxes">
          <mat-checkbox color="primary" *ngFor="let level of levelOptions" [(ngModel)]="level.checked"
            class="status-filter-checkbox" (click)="$event.stopPropagation()">
            {{ level.label }}
          </mat-checkbox>
        </div>
        <div class="status-filter-actions" style="display: flex; justify-content: space-between; padding: 8px;">
          <button mat-button (click)="cancelLevelFilter(); levelFilterMenu?.closeMenu()"
            class="btn btn-outline btn-spacing"
            style="border: 2px solid #1976D2; color:#1976D2; font-weight:500;">Clear</button>
          <button mat-flat-button color="primary" (click)="applyLevelFilter(); levelFilterMenu?.closeMenu()"
            class="btn btn-primary" style="background: #1976D2; color: white;">Apply</button>
        </div>
      </mat-menu>

      <!-- Reminded Date -->
      <ng-container matColumnDef="remindedDate">
        <mat-header-cell *matHeaderCellDef>Reminded Date</mat-header-cell>
        <mat-cell *matCellDef="let element">{{element.remindedDate | date:'yyyy-MM-dd'}}</mat-cell>
      </ng-container>

        <!-- Org Code -->
        <ng-container matColumnDef="organizationCode">
          <mat-header-cell *matHeaderCellDef>Org Code
            <!-- <button class="filter-button" [matMenuTriggerFor]="orgFilterMenu">
              <span class="material-symbols-outlined filter-icon">filter_alt</span>
            </button> -->
          </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <span>
              {{ element.organizationCode || 'Not available' }}
            </span>
          </mat-cell>
        </ng-container>
        <!-- <mat-menu #orgFilterMenu="matMenu">
          <div class="status-filter-checkboxes">
            <mat-checkbox color="primary" *ngFor="let org of orgOptions" [(ngModel)]="org.checked"
              class="status-filter-checkbox" (click)="$event.stopPropagation()">
              {{ org.label || 'Not available' }}
            </mat-checkbox>
          </div>
          <div class="status-filter-actions" style="padding:10px;">
            <button mat-button (click)="cancelOrgFilter(); orgFilterMenu?.closeMenu()" class="btn btn-outline btn-spacing"
              style="border: 2px solid #1976D2; color:#1976D2; font-weight:500;">Clear</button>
            <button mat-flat-button color="primary" (click)="applyOrgFilter(); orgFilterMenu?.closeMenu()"
              class="btn btn-primary" style="background: #1976D2; color: white; margin-left: 8px;">Apply</button>
          </div>
        </mat-menu> -->

      <!-- Status -->
      <ng-container matColumnDef="updatedStatus">
        <mat-header-cell *matHeaderCellDef>Updated Status<button class="filter-button" [matMenuTriggerFor]="statusFilterMenu">
      <span class="material-symbols-outlined filter-icon">filter_alt</span>
    </button></mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.updatedStatus }}</mat-cell>
      </ng-container>
      <mat-menu #statusFilterMenu="matMenu">
  <div class="status-filter-checkboxes">
    <mat-checkbox color="primary" *ngFor="let status of updatedStatusOptions" [(ngModel)]="status.checked"
      class="status-filter-checkbox" (click)="$event.stopPropagation()">
      {{ status.label }}
    </mat-checkbox>
  </div>
  <div class="status-filter-actions" style="display: flex; justify-content: space-between; padding: 8px; gap: 8px;">
    <button mat-button (click)="cancelStatusFilter(); statusFilterMenu?.closeMenu()"
      class="btn btn-outline btn-spacing"
      style="border: 2px solid #1976D2; color:#1976D2; font-weight:500;">Clear</button>
    <button mat-flat-button color="primary" (click)="applyStatusFilter(); statusFilterMenu?.closeMenu()"
      class="btn btn-primary" style="background: #1976D2; color: white;">Apply</button>
  </div>
</mat-menu>

      <!-- Updated On -->
      <ng-container matColumnDef="updatedOn">
        <mat-header-cell *matHeaderCellDef>Updated On</mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.updatedOn ? (element.updatedOn | date:'yyyy-MM-dd') : '' }}
        </mat-cell>
      </ng-container>
      <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
      <mat-row [class.odd]="i % 2 == 1" [class.even]="i % 2 == 0"
        *matRowDef="let row; columns: displayedColumns; let i = index;">
      </mat-row>
    </table>

    <div *ngIf="!isLoading && data?.length === 0" class="no-records-container">
      <div class="no-records">
        <img src="../../../assets/images/no_data.png" height="120px"><br>
        <span class="mt-3 d-block"> No records found for the search criteria </span>
      </div>
    </div>

    <mat-paginator [length]="totalRecords" [pageSize]="10" [pageSizeOptions]="[10,20,30,40,50,60]"
      aria-label="Select page" (page)="getPaginatorData($event)"
      style="height: 8vh; background: inherit; width: 98%; margin-left: 16px;">
    </mat-paginator>
  </div>
</div>